// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"7":"daa12070","228":"9681e640","312":"ad437fa8","453":"670e15c7","457":"911b5ad0","663":"860fa5ed","851":"b8b870c7","862":"e29dda79"}[chunkId] + ".chunk.js";
};